;(function($){

	$(function(){

		$('.btnLightbox').on('click',function(e){
			e.preventDefault();

			$(this).colorbox({
				inline:true,
				className: 'btnLightboxWrapper',
				maxWidth: '80%',
				href: $(this).parent().find('.lightboxContent > div'),
				onComplete: function() { 
				       $('#colorbox').colorbox.resize(); 
				       $(window).trigger('resize'); 
				       console.log('onComplete');
				       setTimeout(function(){
				       		$(window).trigger('resize'); 
	                        $('#colorbox').colorbox.resize();
	                        console.log('onComplete timeout');
	                   },500);
				       $.colorbox.position();
				}    
			});
		});

	});

})(jQuery);